export const emptyMessageTitle = 'Find form and e-file information';
export const emptyMessageLine =
  'Select a return type and agency to see the \nstatus of forms and schedules.';
export const noResultFoundMsg = 'No results found';
export const NOT_RELEASED_YET_MSG = 'Not yet released';
export const NOT_RELEASE_MSG =
  "We haven't released this year's forms for this return type and agency.";
export const NOT_RELEASE_2_MSG = 'For more details,';
export const DESKTOP_WIDTH = 768;
export const MOBILE_WIDTH = DESKTOP_WIDTH + 1;
export const NOT_RELEASE_ANCHOR_LINK =
  'https://www.thomsonreuters.com/en-us/help/ultratax-cs/get-started/install-and-update/release-information.html';
export const NOT_RELEASE_ANCHOR_TEXT = 'go to our release schedule.';
export const NO_RESULT_FOUND_TABLE_LINE_ONE = 'We didn’t find any results for';
export const noResultFoundTableLine2 = 'Try a different form or schedule name.';
export const noResultFoundDefaultMsg =
  'We didn’t find any results for search term. Try a different form or schedule name.';
export const analyticsTextForUtSelector = 'returnTypeAndAgencySearch';
export const analyticsTextForUtSearchResults = 'formOrScheduleNameSearch';
